<template>
  <div class="service-container" ref="container">
    <div>
      <div class="content" :style="conHeight">
        <div class="contents">
          <el-row style="height:100%" :gutter='20'>
            <el-col :span="17" style="height:100%;padding-top:3vh;" >
              <div class="serviceMap">
                <baidu-map :center="map.center" :mapClick="false" :zoom="map.zoom" class="map" @ready="handler" style="height:87vh;overflow:hidden;min-height:600px;margin-bottom:1.5vh" :scroll-wheel-zoom='true'>
                  <bm-control>
                      <bm-auto-complete :sugStyle="{ zIndex: 999999 }">
                          <el-input v-model="map.center" placeholder="请输入搜索关键字" style="margin:10px 0 0 10px" @input="setZoom">
                              <template slot="prepend"><span>搜索：</span></template>
                          </el-input>
                      </bm-auto-complete>
                  </bm-control>
                </baidu-map>
              </div>
            </el-col>
            <el-col :span="7" style="height:100%">
              <div class="leftBox">
                <img :src="leftBox">
                <div class="leftBoxInfo">
                  <div class="title">
                    <span>报警提示</span><img :src="titleImg">
                  </div>
                  <div style="margin-top:20px;padding:0 4% 0 5%">
                    <template>
                      <el-table
                          :data="tableData1"
                          stripe
                          style="width: 100%" height="70vh">
                          <el-table-column
                          prop="remarks"
                          label="报警信息">
                          </el-table-column>
                          <el-table-column
                          prop="deviceName"
                          label="报警设备">
                          </el-table-column>
                          <el-table-column
                          prop="createTime"
                          :formatter="getCreateTime"
                          width="180"
                          label="报警时间">
                          </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="elderlyInfo">
      <el-dialog :visible.sync="dialogTableVisible" top="18vh" width='600px' @closed='closeChild'>
          <div class="modal">
            <img class="backgroundImg" :src="modal">
            <div class="cont">
              <div class="head">
                <img v-show="dataInfo.heardImg" :src="imgUrl+dataInfo.heardImg">
                <div>
                  <div><span style="font-size:26px;font-weight: bold;">{{dataInfo.name}}</span> <span>{{dataInfo.phone}}</span></div>
                  <div><span>{{dataInfo.zoneName}}</span></div>
                </div>
              </div>
              <div class='lable'>
                <div class="lablemin" v-for='(item,i) in lableValue' :key='i' @click="lableopen(i)">
                  <img class="lableImg" :src="item.img">
                  <div :style="item.color">
                    <span>{{item.name}}</span>
                  </div>
                </div>
              </div>
              <!-- <transition name="el-zoom-in-top"> -->
                <div v-show="basicInfo" style="margin-top:20px">
                  <div class="basicInfoList">
                    <div><span>身份证：</span></div>
                    <span>{{dataInfo.idCard}}</span>
                  </div>
                  <div class="basicInfoList" style="background:rgba(13, 57, 117, 0.5)">
                    <div><span>出生日期：</span></div>
                    <span>{{timefilter(dataInfo.birthday)}}</span>
                  </div>
                  <div class="basicInfoList">
                    <div><span>家庭地址：</span></div>
                    <span>{{dataInfo.homeAddress}}</span>
                  </div>
                  <div class="basicInfoList" style="background:rgba(13, 57, 117, 0.5)">
                    <div><span>婚姻：</span></div>
                    <span>{{getIsMarriage(dataInfo.isMarriage)}}</span>
                  </div>
                </div>
              <!-- </transition> -->
              <!-- <transition name="el-zoom-in-top"> -->
                <div v-show="serviceLog" style="margin-top:20px">
                  <template>
                    <el-table
                        :data="tableData"
                        stripe
                        style="width:510px" height="320px">
                        <el-table-column
                        prop="zoneName"
                        label="服务社区">
                        </el-table-column>
                        <el-table-column
                        prop="goodsName"
                        label="服务项目">
                        </el-table-column>
                        <el-table-column
                        prop="orderServe.startTime"
                        :formatter="timefilter1"
                        label="服务日期">
                        </el-table-column>
                        <el-table-column
                        prop="serveName"
                        label="服务人员">
                        </el-table-column>
                        <el-table-column
                        prop="time"
                        label="时长/数量"
                        :formatter="getTime">
                        </el-table-column>
                    </el-table>
                  </template>
                </div>
              <!-- </transition> -->
            </div>
          </div>
      </el-dialog>
    </div>
    <div class="heathInfo">
      <el-dialog  :fullscreen='true' :visible.sync="childOne" :modal='false' @opened='openedChild' @close='closeChild'>
        <IndexChildOne ref="indexChildOne" v-on:close="closeChild"></IndexChildOne>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import { BmlMarkerClusterer } from 'vue-baidu-map'
/* eslint-disable */
import 'element-ui/lib/theme-chalk/base.css';
import styleJson from "@/common/custom_map_config.json"
import IndexChildOne from "./IndexChildOne"
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import { getToken,getInsNameByDomainName } from '@/utils/auth';
export default {
  name: "Home",
  data() {
    return {
      govermentCodeList: [],
      plateFormList: [],
      lableValue:[{name:'基本信息',img:require('./img/lable1.png'),color:{color:'rgba(0, 17, 37, 1)'}},
      {name:'健康档案',img:require('./img/lable.png'),color:{color:'rgba(0, 236, 252, 1)'}},
      {name:'服务记录',img:require('./img/lable.png'),color:{color:'rgba(0, 236, 252, 1)'}},
      ],
      leftBox:require('./img/leftBox.png'),
      titleImg:require('./img/titleImg.png'),
      modal:require('./img/modal.png'),
      head:require('./img/head.png'),
      lable:require('./img/lable.png'),
      icon:require('./img/icon.png'),
      lable1:require('./img/lable1.png'),
      dialogTableVisible:false,
      childOne:false,
      serviceLog:false,
      imgUrl:this.$imgUrl,
      basicInfo:true,
      tableData:[
      ],
      greenDataSet:'',
      mapvLayer: '',
      tableData1:[],
      mapData:[],
      pageIndex:1,
      pageSize:1000,
      pageIndexShop:1,
      pageSizeShop:1000,
      options:{},
      dataInfo:'',
      map:{
        center:{lng: 114.023598, lat: 33.589299},
        zoom:5,
      },
      ms:[],
      mapStyle:{
        styleJson:styleJson
      },
      conHeight: {
        height: ''
      },
    }
  },
  mounted() {
    this.$nextTick(() => { // 页面渲染完成后的回调
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    })
    this.init()
  },
  components: {
    // BmlMarkerClusterer,
    IndexChildOne},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
      this.conHeight.height = this.$refs.container.offsetHeight - 90 + 'px'
    },
  },
  methods: {
    getCreateTime(row){
      return timefilters(row.createTime);
    },
    init() {
      // update是一个函数，['title', '乐庭服务对象']是函数的参数值
      this.$store.commit('update', ['title', getInsNameByDomainName()+'服务对象']);
      /*var date=new Date();
      for(var i=0;i<30;i++){
        var index=parseInt(Math.random()*1000,10);
        date=new Date(date.getTime()-(24*60*1000*index));
        var mi=index%2
        var dataList={
          date: '老人报警',
          name: mi==1?'小乐机器人':'小乐手表',
          address: timefilters(date).replace(/-/g,'/'),
        }
        this.tableData1.push(dataList);
      }*/
      this.getBaoJingTiShi();

    },
    getBaoJingTiShi(){
      var token =JSON.parse(getToken());
      if(token.visualAccountComadmCommunityCodeList.length>0){
        if(token.visualAccountComadmCommunityCodeList[0] === "getAll"){
          this.plateFormList.push("comadm");
        }else {
          token.visualAccountComadmCommunityCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      if(token.visualAccountHomeGovernmentCodeList.length>0){
        if(token.visualAccountHomeGovernmentCodeList[0] === "getAll"){
          this.plateFormList.push("home");
        }else {
          token.visualAccountHomeGovernmentCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      if(token.visualAccountInsGovernmentCodeList.length>0){
        if(token.visualAccountInsGovernmentCodeList[0] === "getAll"){
          this.plateFormList.push("institution");
        }else {
          token.visualAccountInsGovernmentCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      if(token.visualAccountShopGovernmentCodeList.length>0){
        if(token.visualAccountShopGovernmentCodeList[0] === "getAll"){
          this.plateFormList.push("shop");
        }else {
          token.visualAccountShopGovernmentCodeList.forEach(ele=>{
            this.govermentCodeList.push(ele);
          })
        }
      }
      this.getAxios(this.$deviceUrl+"AlarmRecord/getBaoJingTiShi",{
        govermentCodeList: this.govermentCodeList,
        plateFormList: this.plateFormList,
      }).then(resolve=>{
          this.tableData1 = resolve;
      })
    },

    setZoom(){
      if(this.map.center){
        this.map.zoom=13
      }else{
        this.map.zoom=5
      }
    },
    handler({ BMap, map }) {
      var mapv = require("mapv");
      // map.setMapStyle(this.mapStyle)
      // map.setMapStyle({style:'midnight'});
      map.setMapStyleV2({
        styleId: '5c78974534ede0f3d27c313340264e0b'
      });
      let redIcon = document.createElement("img");
      redIcon.src = require("./img/icon.png");
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      map
      // 中心坐标
      const that = this; // 改变this 指向
      // 图片加载完成
      // 储存各点数据
      this.options = {
          draw: "icon",
          width: 22.5, // 规定图像的宽度
          height: 30, // 规定图像的高度
          size: 22.5, // 添加点击事件时候可以用来设置点击范围
          methods: {
              click: function(item) {
                if(item)that.markclick(item)
              }
          },
      };
      console.log(JSON.parse(getToken()).visualAccountShopGovernmentCodeList)
      console.log("=========================================================");
      console.log(map);
      console.log(redIcon);
      console.log(mapv);
      this.getData(map,redIcon,mapv)
      this.getDataShop(map,redIcon,mapv)
    },
    getDataShop(map,redIcon,mapv){
      this.getAxios(this.$shopUrl+"Views/GetElderlyList",{
        governmentCodeList:JSON.parse(getToken()).visualAccountShopGovernmentCodeList,
        pageIndex:this.pageIndexShop,
        pageSize:this.pageSizeShop
      }).then(resolve=>{
          var mapData=[]
          for(var i in resolve.list){
            mapData.push({
                geometry: {
                type: "Point",
                coordinates: [resolve.list[i].lon, resolve.list[i].lat]
                },
                data:resolve.list[i],
                icon: redIcon, // 图标
            })
          }
          this.mapData=this.mapData.concat(mapData)
          if(this.mapvLayer){
            this.greenDataSet.set(this.mapData)
          }else{
            this.greenDataSet = new mapv.DataSet(mapData);
            this.mapvLayer = new mapv.baiduMapLayer(
              map,
              this.greenDataSet,
              this.options
            );
          }
          if(resolve.list.length==this.pageSizeShop){
            this.pageIndexShop++;
            // this.pageSize+=200;
            this.getDataShop(map,redIcon,mapv)
          }
      })
    },
    getData(map,redIcon,mapv){
      console.log("JSON.parse(getToken()).visualAccount.visualAccountCode   ",JSON.parse(getToken()).visualAccount.visualAccountCode);
      this.getAxios(this.$visualizationUrl+"Views/GetElderlyList",{
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
        visualAccountCode:JSON.parse(getToken()).visualAccount.visualAccountCode
      }).then(resolve=>{
        var mapData=[]
        for(var i in resolve.list){
          mapData.push({
              geometry: {
              type: "Point",
              coordinates: [resolve.list[i].lon, resolve.list[i].lat]
              },
              data:resolve.list[i],
              icon: redIcon, // 图标
          })
        }
        this.mapData=this.mapData.concat(mapData)
        if(this.mapvLayer){
          this.greenDataSet.set(this.mapData)
        }else{
          this.greenDataSet = new mapv.DataSet(mapData);
          this.mapvLayer = new mapv.baiduMapLayer(
            map,
            this.greenDataSet,
            this.options
          );
        }
        if(resolve.list.length==this.pageSize){
          this.pageIndex++;
          // this.pageSize+=200;
          this.getData(map,redIcon,mapv)
        }
      })
    },
    closeChild(){
      this.childOne=false
      this.lableValue=[{name:'基本信息',img:require('./img/lable1.png'),color:{color:'rgba(0, 17, 37, 1)'}},
        {name:'健康档案',img:require('./img/lable.png'),color:{color:'rgba(0, 236, 252, 1)'}},
        {name:'服务记录',img:require('./img/lable.png'),color:{color:'rgba(0, 236, 252, 1)'}},
      ]
      this.serviceLog=false
      this.basicInfo=true
    },
    timefilter(data){
      return timefilters(data).slice(0,10)
    },
    timefilter1(row,index,column){
      return timefilters(column).slice(0,10)
    },
    getIsMarriage(data){
      var value=''
      switch(data){
        case -1:
          value='未知'
          break;
        case 0:
          value='未婚'
          break;
        case 1:
          value='已婚'
          break;
        case 2:
          value='离异'
          break;
        case 3:
          value='丧偶'
          break;
        case 4:
          value='再婚'
          break;
      }
      return value;
    },
    getAxios(url,data){
        return new Promise((resolve, reject) => {
          var data1={
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            }
          Object.assign(data1,data)
          this.$axios({
              method: 'post',
              url: url,
              data:data1
          }).then( (response)=> {
              if(response.data.error == 0){
                  resolve(response.data.data);
              }else if(response.data.error == 1){
                  this.$message({type: 'info', message: response.data.message});
              }
          }).catch(function (error) {
              reject(error.data)
          });
        });
    },
    selectFrom(iFirstValue,iLastValue){
        var iChoces = Math.abs(iLastValue - iFirstValue)+1;
        return Math.floor(Math.random() * iChoces + iFirstValue);
    },
    markclick(data){
      this.dataInfo=data.data
      this.tableData=[]
      this.$axios({
          method: 'post',
          url: this.$visualizationUrl+'Views/GetServe',
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            elderlyCode:data.data.elderlyCode,
            pageIndex:1,
            pageSize:20
          }
      }).then( (response)=> {
        if(response.data.error == 0){
            this.tableData=response.data.data.list
        }else if(response.data.error == 1){
            this.$message({type: 'info', message: response.data.message});
        }
      })
      this.dialogTableVisible=true
      // this.$router.push({ path: '/ServiceObject/IndexChildOne'})
    },
    lableopen(index){
      for(var i in this.lableValue){
        this.lableValue[i].img=this.lable
        this.lableValue[i].color={color:'rgba(0, 236, 252, 1)'}
      }
      this.lableValue[index].img=this.lable1
      this.lableValue[index].color={color:'rgba(0, 17, 37, 1)'}
      this.basicInfo=false
      this.serviceLog=false
      switch(index){
        case 0:
          this.basicInfo=true
          break;
        case 1:
          this.childOne=true
          // this.$refs.indexChildOne.init(this.dataInfo)
          break;
        case 2:
          this.serviceLog=true
          break;
        case 3:
          break;
      }

    },
    getTime(row){
      return row.time=='0天0小时0分0秒'?"---":row.time
    },
    openedChild(){
      this.$refs.indexChildOne.init(this.dataInfo)
    }
  }
}


</script>

<style lang="scss" scoped>
.service-container {
  width: 100%;
  height: 100vh;
  margin-top: -75px;
  background-image: url(./childOneImg/background.jpg);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center top;
  min-width: 1360px;
  min-height: 736px;
  .modal{
    height: 510px;
    position: relative;
    .backgroundImg{
      height: 113%;
      width: 104.5%;
      top: -30px;
      left: -20px;
      position: absolute;
    }
    .cont{
      // width: 100%;
      height: 100%;
      position: relative;
      padding: 20px;
      .head{
        color: rgba(0, 204, 255, 1);
        font-size: 20px;
        line-height: 40px;
        margin-bottom:40px;
        width: 100%;
        display: flex;
        align-items: center;
        img{
          float: left;
          height: 90px;
          width: 90px;
          margin-right: 20px;
        }
      }
      .basicInfoList{
        height: 38px;
        width: 510px;
        color: white;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        font-size: 16px;
        line-height: 38px;
        div{
          display: inline-block;
          width: 80px;
          text-align: right;
          color: rgba(0, 204, 255, 1);
        }
      }
      .lable{
        width: 100%;
        display: flex;
        justify-content:left;
        cursor: pointer;
        .lablemin{
          width: 92px;
          height: 32px;
          position: relative;
          margin-right: 10px;
          .lableImg{
            width: 100%;
            height:  100%;
            position: absolute;
          }
          div{
            position: relative;
            text-align: center;
            color: rgba(0, 236, 252, 1);
            font-size: 16px;
            line-height: 32px;
          }
        }

      }

    }
  }
  .elderlyInfo{
    /deep/ .el-dialog{
      background: transparent;
    }
  }
  .heathInfo{
    /deep/ .el-dialog__body {
      padding:0;
    }
  }
  /deep/ .el-input-group__prepend {
      background: rgba(1, 128, 201, 1);
      color: rgb(242, 248, 248);
      border: 1px solid rgba(0, 236, 252, 1);
      border-right: 0;
  }
  ::-webkit-input-placeholder { /* WebKit browsers */
    color: white;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: white;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color: white;
  }
  /deep/ .el-input-group--prepend .el-input__inner{
     background: rgba(1, 128, 201, 0.6);
        color: white;
        border: 1px solid rgba(0, 236, 252, 1);
  }
  /deep/ .el-dialog__header{
    padding: 0;
  }
  /deep/ .el-dialog__headerbtn{
    z-index: 1;
    font-size: 30px;
    right: 16px;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: rgba(28, 226, 255, 1);
    border: 1px solid #1ce2ff;
    border-radius: 5px;
    padding: 2px 2px 6px 6px;
    border-bottom-left-radius: 50px;
    border-bottom-left-radius: 5px;
    border-bottom-left-radius: 40px;
    z-index: 20;
  }
  /deep/ .el-table {
      background-color:transparent;
  }
  .el-table::before {
      height: 0px;
  }
  /deep/ .el-table th {
      background-color:rgba(17, 55, 107, 1);
  }
  /deep/ .el-table__row td{
      border: none;
  }
  /deep/ .el-table__header tr {
    // background-image: linear-gradient(to right,rgba(1, 125, 252, 1),rgba(5, 140, 255, 0.01));
    background-color: rgba(17, 55, 107, 1);
  }
    /deep/ .el-table__body .el-table__row{
        background-color: transparent;
  }
    /deep/ .el-table__body .el-table__row--striped td{
        background-color:rgba(13, 57, 117, 0.5);
  }
  /deep/ .el-table th.is-leaf {
    border: 0;
  }
  /deep/ .el-table__header .cell {
      color: rgba(28, 252, 255, 1);
  }
  /deep/ .el-table td div {
      color: rgba(161, 212, 255, 1);
  }
  /deep/  .el-table__body{
      width: 100% !important;
  }
  /deep/ .el-table__header .gutter{
      display: none !important;
  }
  /deep/ .el-table tbody tr:hover>td {
      background-color:transparent!important
  }
  /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {width: 17px;}
  /deep/  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 10px;
      display: none;
      background: #00FFFF;
  }
  /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
      border-radius: 0;
      background: transparent;
  }
  .content {
    height: 100%;
    margin: 0;
    padding: 0;
    // margin-top: 80px;
    padding: 0 2.6vw;
    padding-top: 90px;
  }

  .contents {
    min-width: 1220px;
    height: 100%;

      .serviceMap{
        border-radius:10px;
        height: 82vh;
        overflow: hidden;
        min-height: 607px;
        border: 1px rgba(9, 101, 237, 1) solid;
      }
      .leftBox{
        height: 85vh;
        min-height: 625px;
        width: 100%;
        position: relative;
        img{
          position: absolute;
          width: 100%;
          height: 100%;
        }
        .leftBoxInfo{
          width: 100%;
          position: relative;
          padding-top: 5vh;
          .title{
            width: 100%;
            text-align: center;
            font-size:28px;
            font-weight:400;
            color:rgba(0,236,252,1);
            line-height:49px;
            img{
              width: 70%;
              height: 18px;
              margin-left: 15%;
              display: block;
              transform: translate(0,-10px);
            }
          }

        }
      }

  }
}

</style>
